import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Button } from '../../components';

const ServerError = () => {
  return (
    <div className="section-gap">
      <Card>
        <div className="text-center py-16">
          <div className="w-24 h-24 bg-danger/20 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg className="w-12 h-12 text-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          
          <h1 className="text-6xl font-bold text-text mb-4">500</h1>
          <h2 className="text-2xl font-semibold text-text mb-4">Internal Server Error</h2>
          <p className="text-muted text-lg mb-8 max-w-md mx-auto">
            Something went wrong on our end. We're working to fix this issue. Please try again later or contact support if the problem persists.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="primary" 
              size="lg" 
              className="px-8"
              onClick={() => window.location.reload()}
            >
              Try Again
            </Button>
            <Link to="/app/dashboard/founder">
              <Button variant="ghost" size="lg" className="px-8">
                Go to Dashboard
              </Button>
            </Link>
          </div>
          
          <div className="mt-12 pt-8 border-t border-line">
            <p className="text-muted text-sm mb-4">If this problem continues, please:</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/contact" className="text-chart hover:text-text transition-colors text-sm">
                Contact Support
              </Link>
              <Link to="/app/settings" className="text-chart hover:text-text transition-colors text-sm">
                Check Settings
              </Link>
              <button 
                onClick={() => window.location.reload()}
                className="text-chart hover:text-text transition-colors text-sm"
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ServerError;
